import React from 'react';
import {AlertsFilterComponent} from '../../../../clean-components/alerts-filter/alerts-filter';

import {Page} from '../../../../clean-components/page/page';

export function AlertsFilter() {
    return <>
        <Page title="translation:misc_alert_filter_title" link="aplicar" action="filter">
            <AlertsFilterComponent/>
        </Page>
    </>;
}
